import '@babel/polyfill';
// Import Component hooks before component definitions
import './component-hooks';
import Vue from 'vue';
import './plugins/vuetify';
import './plugins/vee-validate';
import App from './App.vue';
import router from './router';
import store from '@/store';
import './registerServiceWorker';
import { Datetime } from 'vue-datetime';
import VueDatepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueBootstrapToasts from 'vue-bootstrap-toasts';
import VueI18n from 'vue-i18n';
import VueVideoPlayer from 'vue-video-player';
import VueNoty from 'vuejs-noty';
import VueClipboard from 'vue-clipboard2';
import VueSwal from 'vue-swal';
// import VueTelInput from 'vue-tel-input';
import VuePhoneNumberInput from 'vue-phone-number-input';
// import 'vuetify/dist/vuetify.min.css';
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/scss/vendor/material-icons.scss';
import './assets/scss/vendor/fontawesome.scss';
import './assets/scss/app.scss';
import './assets/scss/vendor/quill.scss';
import './assets/dist/vue-luma.css';
import './assets/css/custom.css';
import 'vue-datetime/dist/vue-datetime.css';
import 'video.js/dist/video-js.css';
import 'vuejs-noty/dist/vuejs-noty.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
// import 'vue-tel-input/dist/vue-tel-input.css';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import {defaultLocale, messages} from '@/i18n';
import moment from 'moment';

// Vue.config.productionTip = false;


Vue.mixin({
  methods: {
    convertDateToStr(date) {
      return moment(String(date)).format('DD/MM/YYYY');
    },
    convertTimeToStr(date) {
      return moment(String(date)).format('HH:mm');
    },
    convertDateTimeToStr(date) {
      return moment(String(date)).format('DD/MM/YYYY HH:mm');
    },
    convertDateTimeToShortStr(date) {
      return moment(String(date)).format('DD MMMM HH:mm');
    },
    showToast(root, msg, type = 'success') {
      if (type === 'success') {
        // @ts-ignore
        root.$toast.success(msg);
      } else if (type === 'error') {
        // @ts-ignore
        root.$toast.error(msg);
      } else if (type === 'warning') {
        // @ts-ignore
        root.$toast.warning(msg);
      } else if (type === 'info') {
        // @ts-ignore
        root.$toast.info(msg);
      }
    },
  },
});

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Datetime);
Vue.use(VueBootstrapToasts);
Vue.use(VueI18n);
Vue.use(VueVideoPlayer);
Vue.use(VueNoty);
Vue.use(VueClipboard);
Vue.use(VueSwal);
// Vue.use(VueTelInput);
Vue.component('datepicker', VueDatepicker);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);


const i18n = new VueI18n({
  messages,
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
});

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
